import { useTheme } from '@mui/material/styles';
import { makePalette, palette } from './palette';

/**
 * The palette of the portal this component is rendering inside.
 *
 * Components in this library are shared by the Government Portal, the Client
 * Portal and the admin tooling, and each of those has its own accent family.
 * Importing the module-level `palette` pins a component to the Government
 * Portal's teal wherever it renders; this follows the theme instead.
 *
 * Only reach for it for the accent — everything else in the palette (ink,
 * surfaces, hairlines, the semantic status colours) is identical across the
 * portals, so the plain import is fine and clearer for those.
 *
 * **Falls back to the default palette.** `useTheme` outside a `ThemeProvider`
 * hands back MUI's own default theme, which carries no `portal` — a bare
 * render in a test, a component mounted above the provider, or a portal added
 * without one. Returning the Government Portal's family there means the
 * component renders on-brand instead of throwing on `undefined.brand`.
 */
export function usePortalPalette(): ReturnType<typeof makePalette> {
  return useTheme().portal ?? palette;
}
